import React, { useState, Children } from 'react';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: 'How do I receive it?',
  answer: 'Instantly. Right after purchase you get immediate access to download everything. No waiting, no shipping. Start today.'
}, {
  question: 'What age is this for?',
  answer: "Children ages 3 to 8. Activities are progressive and naturally adapt to your child's current level."
}, {
  question: 'Do I need special knowledge to use it?',
  answer: 'Not at all. If you can print a page, you can run this system.'
}, {
  question: 'How quickly will I see results?',
  answer: 'Most parents report noticeable changes within the first week of use.'
}, {
  question: 'Can I use it for more than one child?',
  answer: 'Yes. One purchase gives you unlimited printing rights forever.'
}, {
  question: 'Does it work for children with ADHD?',
  answer: "Many parents of children with ADHD report significant positive results. Always consult your child's specialist for specific concerns."
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-16 px-4 bg-gray-50" data-id="element-104">
      <div className="max-w-3xl mx-auto" data-id="element-105">
        <div className="text-center mb-12" data-id="element-106">
          <h2 className="text-3xl md:text-5xl font-black text-gray-900 mb-4" data-id="element-107">
            ❓ Frequently Asked Questions
          </h2>
          <div className="w-24 h-2 bg-blue-600 mx-auto rounded-full" data-id="element-108"></div>
        </div>

        <div className="space-y-3" data-id="element-109">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden" data-id="element-110">
              <button onClick={() => toggle(index)} className="w-full flex items-center justify-between p-5 md:p-6 text-left cursor-pointer" data-id="element-111">
                <span className="text-lg md:text-xl font-bold text-gray-900 pr-4" data-id="element-112">
                  {faq.question}
                </span>
                <ChevronDownIcon className={`w-5 h-5 md:w-6 md:h-6 text-gray-500 flex-shrink-0 transition-transform duration-200 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-113" />
              </button>
              {openIndex === index && <div className="px-5 md:px-6 pb-5 md:pb-6" data-id="element-114">
                  <p className="text-base md:text-lg text-gray-600 font-medium leading-relaxed" data-id="element-115">
                    {faq.answer}
                  </p>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}